/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
import { Image, Row, Tooltip } from "antd";
import { TrunkList } from "components/Common/PerlickCommon/PerlickList/PerlickCHOrderList";
import { ICHOrderDetailsRequest } from "interfaces/APIInterface/IPerlickAPIInterface/ICHOrder";
import {
  IPerlickChOrderDetailsResponse,
  TrunkItem,
} from "interfaces/ClientInterface/PerlickClientInterface/ICHOrder";
import React, { useEffect, useState } from "react";
import { PerlickTrunkList } from "./PerlickCH.Constant";
import { IColumnProps } from "interfaces/ClientInterface/IEditOrder";
import { PERLICK_ROUTES_PATH } from "routes/PerlickRoutes.Constant";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import eye from "assets/images/eye.svg";
import { themeSetting } from "config/defaultSettings";
import { PerlickCHOrderDetailsList } from "api/services/PerlickAPICalls/PerlickCHOrder.api";
import { checkUserSession } from "utils";
import { ROUTES_PATH } from "routes/Routes.Constant";
import PerlickCHDetailsCard from "./PerlickCHDetailsCard";
import CollapseComponent from "components/Common/Collapse/Collapse";
import PerlickCHOrderSummaryHeader from "./CHOrderSummary/PerlickCHOrderSummaryHeader";

const PerlickCHOrderDetails = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sysId = searchParams.get("sysId");
  // const salesRepId = searchParams.get("salesRepId");

  const columnData = PerlickTrunkList();
  const [columnsList] = useState(columnData as IColumnProps[]);
  const [isLoading, setIsLoading] = useState(false);
  const [numberOfRecords, setNumberOfRecords] = useState(0);
  const [sortingColumn, setSortingColumn] = useState({
    sortByColumnName: "",
    sortType: "",
  });
  const [chOrderData, setCHOrderData] = useState<IPerlickChOrderDetailsResponse>(
    {} as IPerlickChOrderDetailsResponse
  );
  const cols = [
    ...columnsList,
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hidden: false,
      width: "100px",
      render: (_text: string, record: TrunkItem) => {
        const { TrunkNo } = record;
        return (
          <Row className="font-18 d-flex">
            <span className="cursor-pointer">
              <Tooltip title="View">
                <Link
                  to={`${PERLICK_ROUTES_PATH.CH_TRUNK_DETAILS}?sysId=${sysId}&TrunkNumber=${TrunkNo}`}
                  target="_self"
                >
                  <Image
                    src={eye}
                    width={15}
                    style={{ fill: themeSetting.token.colorPrimary }}
                    preview={false}
                  />
                </Link>
              </Tooltip>
            </span>
          </Row>
        );
      },
    },
  ];

  const fetchCHOrderDetails = async () => {
    setIsLoading(true);
    try {
      const request: ICHOrderDetailsRequest = {
        OrderNumber: Number(sysId),
      };
      const response = await PerlickCHOrderDetailsList(request);
      const data = response?.data?.OrderDetails?.[0] || [];
      setCHOrderData(data);
      setNumberOfRecords(data.length);
    } catch {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (checkUserSession()) {
      if (sysId) {
        fetchCHOrderDetails();
      } else {
        navigate(ROUTES_PATH.CENTURY_HISTORY_ORDER);
      }
    } else {
      navigate(ROUTES_PATH.LOGOUT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sysId]);

  return (
    <div className="p-15 h-100">
     
      <CollapseComponent
        size="small"
        title= {<PerlickCHOrderSummaryHeader orderDetails={chOrderData} />}
        defaultActiveKey={"1"}
        dataTestSelector="collapseOrderSummary"
        className="collapse-tables"
      >
        <PerlickCHDetailsCard chOrderData={chOrderData} />
      </CollapseComponent>

      <CollapseComponent
        size="small"
        title={<div className="title-style">Trunk List</div>}
        defaultActiveKey={"1"}
        dataTestSelector="collapseOrderSummary"
      >
        <TrunkList
          showClass={true}
          NumberOfRecords={numberOfRecords}
          data={chOrderData?.TrunkList}
          columns={cols?.filter((item) => !item.hidden)}
          pagination={false}
          classSelector={"dashboard-listing-container"}
          isLoading={isLoading}
          sortingColumn={sortingColumn}
          setSortingColumn={setSortingColumn}
        />
      </CollapseComponent>
      
    </div>
  );
};
export default PerlickCHOrderDetails;
